<template>
    <div>
        <div class="w-16 lg:w-40 hidden md:block">
            <div class="w-16 lg:w-40 fixed h-screen top-0 left-0 bg-purple-dark">
                <div class="h-full relative flex items-center w-full">
                    <div class="logo-container w-full inset-x-0 mx-auto">
                        <img src="@/assets/svg/min-logo.svg" alt="" class="mx-auto" />
                    </div>
                    <nav class="w-full">
                        <ul class="w-full">
                            <router-link
                                tag="li"
                                :class="
                                    `nav_item relative flex flex-col items-center justify-center mt-6  first-child:mt-0 lg:ml-3 cursor-pointer ${
                                        active(item.icon) ? 'active' : ''
                                    }`
                                "
                                v-for="item in navItems"
                                :key="item.icon"
                                :to="item.route"
                            >
                                <div class=""></div>
                                <img
                                    :src="require(`@/assets/svg/${item.icon}.svg`)"
                                    :alt="item.text + 'icon'"
                                    class="lg:mb-3"
                                />
                                <p class="text-white text-sm font-medium hidden lg:block" v-html="item.text"></p>
                            </router-link>
                        </ul>
                    </nav>
                    <div class="footer-wrapper w-full inset-x-0 mx-auto lg:flex justify-center hidden">
                        <p class="text-sm text-purple-pale mx-auto">&copy; Billerpay.co</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="absolute right-0 top-0 pr-3 md:px-10 z-20">
            <biller-notification />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            navItems: [
                {
                    icon: 'bills',
                    text: 'Bills Payment',
                    route: '/bills',
                },
                {
                    icon: 'transfer',
                    text: 'Funds Transfer',
                    route: '/transfer/form',
                },
                {
                    icon: 'airtime-data',
                    text: 'Airtime &amp; Data',
                    route: '/airtime-data',
                },
            ],
        }
    },

    methods: {
        active: function(page) {
            return this.$route.path.includes(page)
        },
    },
}
</script>

<style lang="scss" scoped>
.logo-container {
    position: absolute;
    top: 5%;
}

.footer-wrapper {
    position: absolute;
    bottom: 5%;
}

.active {
    background: theme('colors.orange.light');
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
}

.nav_item {
    height: 7.4rem;
    @media (max-width: 768px) {
        height: 5rem;
    }
}
</style>
